<script>
  import '@awesome.me/webawesome-pro/dist/components/button/button.js';
  import { authState, login } from '#state/auth';
  import ProfileButton from './ProfileButton.svelte';

  function handleLoginClick() {
    login();
  }
</script>

<div class="wa-flank wa-align-items-center" style="width: 100%;">
  <div class="title">
    <h2>Godot Asset Library</h2>
  </div>
  <div class="actions">
    {#if authState.isAuthenticated === true}
      <ProfileButton />
    {:else}
      <wa-button
        variant="brand"
        appearance="outlined"
        onclick={handleLoginClick}
      >
        Login
      </wa-button>
    {/if}
  </div>
</div>

<style>
  .actions {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }
</style>